import { useFormikContext } from 'formik';
import { useState } from 'react';
import { DownloadAs } from '../../../../../components/DownloadAs';
import { useReportCtx } from '../../../report-ctx';

/**
 * Dropdown for report download with predefined formats
 */
export const DownloadReportBtn = () => {
  const fp = useFormikContext<{ _format: string }>();
  const ctx = useReportCtx();
  const [loading, setLoading] = useState(false);

  return (
    <DownloadAs
      formats={ctx.formats || []}
      disabled={!fp.isValid || ctx.isLoading}
      loading={loading}
      onDownload={(format) => {
        setLoading(true);
        ctx.downloadReport(format).finally(() => {
          setLoading(false);
        });
      }}
    />
  );
};
